import { css } from '@emotion/css';

import { ScreenBreakpoint, Font, Display, Color, Spacing, FlexDirection, AlignItems } from '../../styles';

export const offeringTypesRow = css`
  @media (max-width: 489px) {
    ${Display.block}
    width: 100%;
  }
`;

export const footerMain = css`
  width: 100%;
  ${Display.flex}
  ${FlexDirection.column}
  ${AlignItems.center}
  background-color: ${Color.Gray3};
  ${Spacing.pt0}
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.p0}
  }
`;

export const sectionContainer = css`
  width: 100%;
  max-width: 75rem;
  @media (max-width: ${ScreenBreakpoint.desktop.max}) {
    ${Spacing.px20}
  }
`;

export const footerLogoSection = css`
  ${Display.flex}
  ${AlignItems.center}
`;

export const footerLogo = css`
  width: 5rem;
  ${Spacing.mr64}
  ${Spacing.my32}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    /* 5rem is 60px at the 12px mobile root. Keep the 16px-root size. */
    width: 80px;
    height: auto;
  }
`;

export const footerTopLink = css`
  ${Spacing.mr32}
  ${Font.sm}
  color: ${Color.Brand5};
  text-decoration: none;
  &:hover {
    color: ${Color.Brand5};
  }
`;

export const subLinksSection = css`
  ${Spacing.mt32}
`;

export const footerSubLink = css`
  ${Spacing.mr32}
  ${Font.sm}

  color: ${Color.Brand5};
  text-decoration: none;

  &:hover {
    color: ${Color.Brand6};
  }

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Display.block}
    ${Spacing.mr0}
    ${Spacing.mt12}
  }
`;
